import { render, staticRenderFns } from "./ChamberRegionsDetail.vue?vue&type=template&id=2f1f9d16&scoped=true&"
import script from "./ChamberRegionsDetail.vue?vue&type=script&lang=js&"
export * from "./ChamberRegionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChamberRegionsDetail.vue?vue&type=style&index=0&id=2f1f9d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f9d16",
  null
  
)

export default component.exports